import { format } from 'date-fns';
import ruLocale from 'date-fns/locale/ru';
import { Notifications } from './types';

const clearFromCssStyle = (value: string) =>
  value.replace(/style=(['"])(?:(?!\1).)*\1/g, '');

const notificationsParcer = (data: Notifications): Notifications => ({
  id: data!.id || '',
  date:
    data.date_created && data.date_created.length
      ? `${format(data.date_created, 'D MMMM YYYY', {
          locale: ruLocale,
        })} года в ${format(data.date_created, 'HH:mm')}`
      : '',
  title: data!.title || '',
  message:
    data.message && data.message.length ? clearFromCssStyle(data.message) : '',
  isRead: data!.is_read || '',
});

export default notificationsParcer;



// WEBPACK FOOTER //
// ./src/services/notifications/utils/notificationsParser.ts